module.exports = __webpack_public_path__ + "img/938000100_4.e458edf6.jpg";